module.exports = __webpack_public_path__ + "static/img/3s-info-b5.8152be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-info-b5.png
// module id = 9ezh
// module chunks = 0